import {
    SET_FLEET_DISPOSITION_LOCATION_SAVE
} from "./FleetDispositionLocationsaveType"

const initialState = {
    fleetDispositionLocationValue: {}
}


const reducer = (state = initialState, action: any) => {
    if(action.type === SET_FLEET_DISPOSITION_LOCATION_SAVE) {
        return {
            ...state,
            fleetDispositionLocationValue : action.fleetDispositionLocationValue
        }
    }
    else {
        return state;
    }
};

export default reducer;